import { UsuariosService } from './../../../services/usuarios.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SucursalesService } from "../../../services/sucursales.service";
import { HelpersService } from "../../../services/tools/helpers.service";
import { ErrorModalComponent } from './../../../components/tools/modals/error-modal/error-modal.component';
declare var $;

@Component({
  selector: 'app-usuarios-modal',
  templateUrl: './usuarios-modal.component.html',
  styleUrls: ['./usuarios-modal.component.scss']
})
export class UsuariosModalComponent implements OnInit {

  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;

  cuentasSelectedOptions: any = [];
  sucursalesOptions : any = [];
  sucursalesFilterOptions: any[];
  rolesOptions : any[];
  rolesFilterOptions: any[];
  rolesSelected: any = {};
  selected: any = {};
  errors: any = {};
  processing: boolean = false;
  inputType: string = 'password';
  passwordChange: boolean = true;
  isUpdate: boolean = false;
  sucursalesSelected: any = {};

  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor(  private usuariosService: UsuariosService,
                private sucursalesService: SucursalesService,
                private helperService: HelpersService,
    ) {
    
  }

  ngOnInit() {
    this.selected = this.usuariosService.getDefaultSchedule();
    this.sucursalesSelected = this.sucursalesService.getDefaultSchedule();
    this.getSucursales();
    this.getRoles();
  }

  getSucursales(){
    this.sucursalesService.getSelect().subscribe(
      (response)=>{
        this.sucursalesFilterOptions = response.json().content;
      }, error => {
        this.processing = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.helperService.notification('ERROR', 'Sucedió un error obtener el listado de sucursales. Por favor, intenta más tarde.', 'error');
        }
    });
  }

  getRoles(){
    this.usuariosService.getRoles().subscribe(
      (response)=>{
        this.rolesFilterOptions = response.json().content;
        //Eliminamos el rol de tipo fondeador
        this.rolesFilterOptions.splice(4,1);
        console.log("Roles: ", this.rolesFilterOptions);
        
      }, error => {
        this.processing = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.helperService.notification('ERROR', 'Sucedió un error obtener el listado de roles. Por favor, intenta más tarde.', 'error');
        }
    });
  }

  showPassword()
  {
    if(this.inputType == 'password')
      this.inputType = 'text';
    else
      this.inputType = 'password';
  }

  reset() {
    this.selected = {};
    this.isUpdate = false;
    this.passwordChange = true;
    this.errors = {};
    this.sucursalesSelected = {};
  }

  close(){
    $('#usuarios-modal').modal('hide');
  }

  open(user) {
    this.reset();
    if(user !== undefined && user !== null)
    {
      this.selected = user;
      this.passwordChange = false;
      this.selected.password = '123456';
      this.isUpdate = true;
      this.sucursalesSelected = user.sucursales;
      this.rolesSelected = user.usuarios_permisos;
    } 
    $('#usuarios-modal').modal('show');
  }

  changePassowrd()
  {
    if(this.isUpdate)
      this.passwordChange = true;
  }

  onKeyup($event) {
    if($event.key == 'Enter') {
      this.accept();
    }
  }

  changeSucursalesSelected(selected) {
    this.sucursalesSelected = selected;
  }

  changeRolesSelected(selected) {
    this.rolesSelected = selected;
  }

  generarPassword(longitud = 10)
  {
    var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
    var pass = "";
    let i;
    for (i=0; i<longitud; i++) pass += caracteres.charAt(Math.floor(Math.random()*caracteres.length));
    this.selected.password = pass;
  }

  accept() {
    this.errors = [];
    if(this.sucursalesSelected.length < 1){
      this.selected.idSucursales = "";
    }
    else
    {
      this.selected.idSucursales = this.sucursalesSelected.id;
    }
    if(this.rolesSelected.length < 1){
      this.selected.idUsuarios_Permisos = "";
    }
    else
    {
      this.selected.idUsuarios_Permisos = this.rolesSelected.id;
    }
    this.errors = this.usuariosService.validate(this.selected);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    this.processing = true;
    this.selected.idroles_Usuarios = 2;
    
    if(this.isUpdate)
      this.update();
    else
      this.create();
    
  }

  create(){
    this.usuariosService.create(this.selected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.helperService.notification('Usuario guardado', 'Se ha creado exitosamente el usuario: ' + this.selected.nombre, 'success');
          this.goToCallback.emit('reload'); // when we emit, we reload the liquidation list
          this.close(); 
        }
      }, error => {
        this.processing = false;
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.close();
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  update() {
    if(!this.passwordChange)
      this.selected.password = '';
    this.usuariosService.update(this.selected, this.selected.id)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          this.helperService.notification('Usuario actualizado', 'Se ha actualizado exitosamente el usuario: ' + this.selected.nombre, 'success');
          this.goToCallback.emit('reload'); 
          this.close();
        }
      }, error => {
        this.processing = false;

        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.close();
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }

        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}


// WEBPACK FOOTER //
// ./src/app/administracion/usuarios/usuarios-modal/usuarios-modal.component.ts